import { useAuth0 } from 'utils/auth'
import { useUserData } from 'components/contexts/UserDataContext'

import { usePfStore } from '../store'

/**
 * The workspace every session-scoped request is addressed to: the one the session was opened in.
 *
 * The backend binds a session to its workspace and refuses a request addressed to another, so
 * re-deriving it from the admin's target or the client's property workspace can disagree with the
 * session — after a resume, or once a property moved workspace. Before a session exists, the
 * workspace it will be opened in.
 */
export const usePfSessionWorkspaceId = (): string | null | undefined => {
  const { roles } = useAuth0()
  const { userPropertyWorkspaceId } = useUserData()
  const sessionWorkspaceId = usePfStore((s) => s.draft.sessionWorkspaceId)
  const adminTargetWorkspaceId = usePfStore((s) => s.targetWorkspaceId)
  return sessionWorkspaceId ?? (roles.isAdmin ? adminTargetWorkspaceId : userPropertyWorkspaceId)
}
